import { Validator } from 'fluentvalidation-ts';
import { MealCountDto, MealCountCalcs, ReceivedMealsHardValidator } from '@/models'

/**
    Typescript Fluent Validation's implementation is not the same as C#'s.
    So it is necessary to create another separate validation
*/
export class MealCountHardValidator extends Validator<MealCountDto> {
  constructor() {
    super();

    this.ruleFor('receivedMeals')
      .setValidator(() => new ReceivedMealsHardValidator());
      
    this.ruleFor('servingLines')
      .must((v, m) => {
        const model = new MealCountCalcs(m);
        return model.availableCount >= model.totalCountWithWaste;
      });
  }
}
